import { Store } from "pullstate";

const SettingsStore = new Store({
  categories: [
    // {
    //   label: "Alberta Diploma Examination",
    //   value: "alberta",
    //   group: "Alberta",
    // },
    // {
    //   label: "Law – CPLED Bar Admission Program",
    //   value: "cpled",
    //   group: "Alberta",
    // },
    // {
    //   label: "Real Estate – RECA Exams",
    //   value: "reca",
    //   group: "Alberta",
    // },
    // {
    //   label: "Trades – AIT Exams",
    //   value: "ait",
    //   group: "Alberta",
    // },
    // {
    //   label: "BC Provincial Graduation Assessments",
    //   value: "bc-provincial",
    //   group: "British Columbia",
    // },
    // {
    //   label: "Bar Admission in British Columbia",
    //   value: "bc-bar",
    //   group: "British Columbia",
    // },
    // {
    //   label: "Real Estate Licensing in BC",
    //   value: "bc-real-estate",
    //   group: "British Columbia",
    // },
    {
      label: "Grade 12 Provincial Tests",
      value: "g12pt",
      group: "Manitoba",
    },
    {
      label: "Nova Scotia Provincial Examinations.",
      value: "nspe",
      group: "Nova Scotia",
    },
    // {
    //   label: "OSSLT (Ontario Secondary School Literacy Test)",
    //   value: "osslt",
    //   group: "Ontario",
    // },
    // {
    //   label:
    //     "OCT Certification – Ontario College of Teachers exam for teachers",
    //   value: "oct",
    //   group: "Ontario",
    // },
    // {
    //   label: "Barrister & Solicitor Exams – Law Society of Ontario.",
    //   value: "ontario-law",
    //   group: "Ontario",
    // },
    // {
    //   label: "OREA Exams – for real estate agents.",
    //   value: "orea",
    //   group: "Ontario",
    // },
    // {
    //   label: "CPA Ontario Exams – for accounting professionals.",
    //   value: "cpa-ontario",
    //   group: "Ontario",
    // },
    // Quebec
    // {
    //   label: "Épreuves ministérielles (DES).",
    //   value: "des",
    //   group: "Quebec",
    // },
    // {
    //   label: "Test de classification en français (TCF).",
    //   value: "tcf",
    //   group: "Quebec",
    // },
    {
      label: "Grade 9 Science PAT",
      value: "g9-pat",
      group: "Saskatchewan",
    },
    {
      label: "Grade 9 Social Studies PAT",
      value: "g9-sspat",
      group: "Saskatchewan",
    },
  ],
});

export default SettingsStore;

